import { FilterOperations } from 'business/definitions';
import React from 'react';
import IdentityComponent from 'ui/IdentityComponent/IdentityComponent';
import RegularYearPicker from '../RegularYearPicker';
import { isDynamicYearFilter } from './definitions';

export type YearFilterManageeProps = {
    filter: SentenceFilterT;
    setFilter: (fields: Partial<SentenceFilterT>) => void;
    isPerimeterFilter?: boolean;
    children: React.ReactElement;
    shouldDebounce?: boolean;
    inputProps?: object;
};

type YearFilterManagee = (args: YearFilterManageeProps) => React.ReactElement;

export const getYearFilterManagee = (
    filter: SentenceFilterT,
): YearFilterManagee => {
    const { value, operation } = filter;
    if (
        (value && isDynamicYearFilter(value)) ||
        operation === FilterOperations.is_null
    ) {
        return IdentityComponent;
    }
    return RegularYearPicker;
};
